import { CustomerFeedbackSubmit, EReviewLink, FilteredCreditApplication, useGetFeedback } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: FilteredCreditApplication
}

const CompletedAppPage = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const [feedback] = useGetFeedback(creditApp.id, EFinancingProgram.MechanicalWarranty)

  const msg = creditApp.loanCreated ? 'common.loanCreated' : 'common.awaitingContractReview'

  return (
    <main className="general-message">
      <h4 className="subtitle">{t('common.goodNews')}</h4>
      <div>
        <h3>{t(msg)}</h3>
      </div>
      {!feedback && (
        <CustomerFeedbackSubmit
          creditApp={creditApp}
          reviewLink={EReviewLink.IcebergFinance}
          financingProgram={EFinancingProgram.MechanicalWarranty}
        />
      )}
    </main>
  )
}

export default CompletedAppPage
